import { atom } from "jotai";
import { Node } from "@xyflow/react";
import { ZslApi } from "@zapier/service-providers";
import { HELPFUL } from "@zapier/canvas-constants";
import { createHash } from "crypto"; // TODO: replace with crypto.subtle

import {
  nodeAtomFamily,
  emitAiPredictionUserFeedbackEventSetter,
  canvasAtom,
  SuggestedNodeData,
} from "../index";

import { isAcceptingSuggestionStateAtom } from "./states";
import { replaceSuggestedWithAcceptedSetter } from "./replaceSuggestedWithAcceptedSetter";

export const acceptSuggestionSetter = atom(
  null,
  async (get, set, nodeId: string) => {
    set(isAcceptingSuggestionStateAtom, true);

    try {
      const canvas = get(canvasAtom);
      const suggestedNode = get(
        nodeAtomFamily(nodeId),
      ) as Node<SuggestedNodeData>;
      if (!suggestedNode) {
        throw new Error("Suggested node not found");
      }

      // Emit the acceptance event before executing ZSL
      set(emitAiPredictionUserFeedbackEventSetter, {
        //prediction id is a hash of the zsl
        prediction_id: createHash("sha256")
          .update(JSON.stringify(suggestedNode.data.zsl))
          .digest("hex"),
        user_rating: HELPFUL,
        user_feedback: "accepted",
        correlation_id: canvas.id,
      });

      const response = await ZslApi.executeZsl({
        template: {
          parameters: [],
          name: "New Template",
          ...suggestedNode.data.zsl,
        },
      });
      set(isAcceptingSuggestionStateAtom, false);
      set(replaceSuggestedWithAcceptedSetter, {
        nodeId,
        executeZslResponse: response,
      });
    } catch (err) {
      set(isAcceptingSuggestionStateAtom, false);
      throw err;
    }
  },
);

acceptSuggestionSetter.debugLabel = "acceptSuggestionSetter";
